import { getSectionType } from './defaults';
import { normalizeColorFill, resolveColorFillStyle } from './colorFillUtils';

/** Voile / griseur configurable sur sections image ou vidéo (alpha via ColorFillField). */
export function resolveSectionBackgroundOverlayStyle(section) {
  const bg = section?.background;
  if (!bg || bg.overlayEnabled === false || !bg.overlay) return null;
  const t = getSectionType(section);
  if (t !== 'image' && t !== 'video') return null;
  const main = resolveColorFillStyle(normalizeColorFill(bg.overlay), 'transparent');
  const footer = 'linear-gradient(0deg, rgba(10, 22, 15, 0.32), transparent 30%)';
  if (bg.overlayFooter === true) {
    if (main.backgroundImage) {
      return {
        backgroundColor: 'transparent',
        backgroundImage: `${main.backgroundImage}, ${footer}`,
      };
    }
    return { backgroundColor: 'transparent', backgroundImage: footer };
  }
  return main;
}

/** Voile horizontal type section réservation (exemple). */
export const DEFAULT_RESERVATION_OVERLAY = {
  mode: 'gradient',
  angle: 90,
  stops: [
    { color: '#152b1f', alpha: 0.96, position: 0 },
    { color: '#152b1f', alpha: 0.82, position: 100 },
  ],
};

export const DEFAULT_IMAGE_OVERLAY = {
  mode: 'gradient',
  angle: 90,
  stops: [
    { color: '#0d1c14', alpha: 0.78, position: 0 },
    { color: '#0d1c14', alpha: 0.56, position: 42 },
    { color: '#0d1c14', alpha: 0.12, position: 100 },
  ],
};
